import { createAsyncThunk } from '@reduxjs/toolkit';
import appointmentService from '../../../api/services/appointment';

export const getClientAppointments = createAsyncThunk('appointment/getClientAppointments', async requestData => {
  return await appointmentService.getClientAppointments(requestData);
});

export const createAppointmentForClient = createAsyncThunk(
  'appointment/createAppointmentForClient',
  async ({ id, body }) => {
    return await appointmentService.createAppointmentForClient(id, body);
  },
);

export const getVendorOccupiedPeriod = createAsyncThunk('appointment/getVendorOccupiedPeriod', async date => {
  return await appointmentService.getVendorOccupiedPeriod(date);
});

export const getAllVendorAppointments = createAsyncThunk('appointment/getAllVendorAppointments', async () => {
  return await appointmentService.getAllVendorAppointments();
});

export const editAppointment = createAsyncThunk('appointment/editAppointment', async ({ id, body }) => {
  return await appointmentService.editAppointment(id, body);
});

export const createUnavailableAppointment = createAsyncThunk('appointment/createUnavailableAppointment', async body => {
  return await appointmentService.createUnavailableAppointment(body);
});

export const acceptClientAppointment = createAsyncThunk(
  'appointment/acceptClientAppointment',
  async ({ appointmentId, notificationId }) => {
    return await appointmentService.acceptClientAppointment(appointmentId, notificationId);
  },
);

export const rejectClientAppointment = createAsyncThunk(
  'appointment/rejectClientAppointment',
  async ({ appointmentId, notificationId }) => {
    return await appointmentService.rejectClientAppointment(appointmentId, notificationId);
  },
);

export const deleteAppointment = createAsyncThunk('appointment/deleteAppointment', async ({ id }) => {
  return await appointmentService.deleteAppointment(id);
});

export const createAppointmentForLeadClient = createAsyncThunk(
  'appointment/createAppointmentForLeadClient',
  async body => {
    return await appointmentService.createAppointmentForLeadClient(body);
  },
);
